<template>
	<div class="col-md-2 col-12 sidebar categorySidebar">
		<div class="cat-menu-container" @click="open=!open">
			<span 
				class="catPlus"
				v-if="mobile"
				:class="open ? 'showChildren' : ''"
			></span>
			<h2 class="cat-menu-header sidebarH2">Shop Categories</h2>
		</div>
		<div 
			class="sidebarInner collapsingSidebar" 
			ref="sidebar"
			:style="(mobile) ? 'max-height:' + height+'px;' : ''"
		>
			<ul>
				<CategorySidebarListItem v-for="category in mainItems"  :key="category.id" :category="category" @openItem="openItem"/>
			</ul>
		</div>
	</div>
</template>

<script>

import CategorySidebarListItem from "./CategorySidebarListItem";
import { mapState } from "vuex";

export default {
	name: 'CategorySidebar',
	data() {
		return {
			mobile:window.innerWidth <= 600,
			openHeight: 0,
			open: false,
			openItems: {}
		}
	},
	components: {
		CategorySidebarListItem
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		mappedCategories(){
			if (!this.categories) return []

			// 1635 = View All Discounts (discount partners)
			// 1458 = Cherrytree
			let hiddenItems = ["1635", "1458"];

			//2 = entertainment
			//4 = auto
			//11= jewellery
			//1880 = showroom Stock
			//1621 = crafts
			//1926 = gift ideas
			// let moreItems = ["2", "4", "11", "1621", "1926"];

			let cats =  Object.values(this.categories).map(category =>{

				if (hiddenItems.includes(category.id)){
					return null;
				}

				// let inMore = false;
				// if(moreItems.includes(category.id)){
				// 	inMore = true;
				// }

				let name = category.category

				let children = null;
				if (category.children){
					children = Object.values(category.children).sort((a,b) => a.category.localeCompare(b.category))
				}
				return {name: name, id: category.id, children: children}//, inMore:inMore, images: category.images}

			})
			cats.push({
				name: "Specials",
			})
			return cats.filter(item => item != null).sort((a,b) => a.name.localeCompare(b.name))
		},
		mainItems(){
			return this.mappedCategories.filter(item => !item.inMore)
		},
		height() { // Try to get this to work properly so that it's dynamic
			if(this.open) {
				let height = 31 * this.mainItems.length;
				for(let openItem in this.openItems) {
					// console.log(openItem)
					height += this.openItems[openItem];
				}
				return height
			}
			return 0;
		},
	},
	methods: {
		openItem(e) {
			this.openItems[e.id] = e.height;
		},
	}
}
</script>

<style lang="scss" scoped>





@include media-breakpoint-down(sm) {
	.categorySidebar {
		padding: 0 15px;
	}
	.collapsingSidebar {
		transition: all ease-in-out 0.5s;
		overflow: hidden;
		// overflow-x: hidden;
		width: 100%;
	}
	.cat-menu-container {
		height: 31px;
		z-index: 10;
		.cat-menu-header {
			height: 100%;
			line-height: 31px;
			// margin-left: 20px;
			vertical-align: top;
			display: inline-block;
		}
		.catPlus {
			width: 44px;
			height: 31px;
			position: relative;
			display: inline-block;
			// background: $CTred;
			&:after, &:before{ 
				content: '';
				background: $CTred;
				position: absolute;
				height: 2px;
				width: 14px;
				top: 50%;
				left: 50%;
				transition: all ease-in-out 0.2s;
				transform: translate(-50%, -50%);
			}
			&:before{ 
				transform: translate(-50%, -50%) rotate(90deg);
			}
			&.showChildren:before {
				transform: translate(-50%, -50%);
			}
		}
	}
}

</style>
